import { IBot, IStory } from '@/interface';
import { fetchBotList, fetchBotListBySpace } from '@/services/bot';
import { fetchStoryList } from '@/services/story';


export const formKeys = {
  managerType: 'managerType',
  name: 'name',
  style: 'style',
  story: 'story',
  others: 'others',
  title: 'title',
  stories: 'stories',
  bots: 'bots',
};

// 目前没用到
export const fetchStoryOptions = async (params?: { spaceId?: string }) => {
  const ret = await fetchStoryList({ size: 9999, ...params, release: true });
  const list: { label: string; value: string; opt: IStory; }[] = [];
  ret.list.forEach((item) => {
    if (item.name && item.id) {
      list.push(({ label: item.name, value: item.id, opt: item }));
    }
  });
  return {
    list,
  };
};

// 目前没用到
export const fetchBotOptions = async (params?: { spaceId?: string }) => {
  const { spaceId = '' } = params || {};
  let ret;
  if (spaceId) {
    ret = await fetchBotListBySpace({ size: 9999, spaceId, release: true });
  } else {
    ret = await fetchBotList({ size: 9999, release: true });
  }
  const list: { label: string; value: string; opt: IBot; }[] = [];
  ret.list.forEach((item) => {
    if (item.name && item.id) {
      list.push(({ label: item.name, value: item.id, opt: item }));
    }
  });
  return {
    list,
  };
};

export enum ChangeDataType {
  INPUT = 1,
  OUTPUT = 2
}
